import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { authService } from '../services/AuthServices';
import { dashboardService } from '../services/DashboardService';
import { notificationsService } from '../services/notificationsService';
import styled from 'styled-components';

const Header = () => {
    const [fullName, setFullName] = useState('');
    const [email, setEmail] = useState('');
    const [notificationCount, setNotificationCount] = useState(6);
    const userId = localStorage.getItem('id');
    const [portfolioData, setPortfolioData] = useState({});
    const [notifications, setNotifications] = useState([]);

    const navigate = useNavigate();

    useEffect(() => {
        fetchNotifications();
        getPortfolioDetails();
        const interval = setInterval(fetchNotifications, 60000);
        return () => clearInterval(interval);
    },[]);

    const fetchNotifications = async () => {
        try {
            const response = await notificationsService.getNotifications(userId);
            const data = response.data?.data || [];
            setNotifications(data);

            const unread = data.filter(notif => !notif.isRead).length;
            setNotificationCount(unread);
        } catch (error) {
            console.error(error.response?.data?.message || "Failed to fetch notifications");
        }
    };


    const getPortfolioDetails = async () => {
        try {
            const response = await dashboardService.portfolioSummary(userId);
            if (response.status === 200 || response.status === 201) {
                setPortfolioData(response.data.data);
            } else {
                console.error("Unexpected response while getting/details:", response);
            }
        } catch (error) {
            console.error('Error fetching or details:', error);
        }
    };

    const handleLogout = async () => {
        localStorage.removeItem('token');
        localStorage.removeItem('id');
        localStorage.removeItem('user');
        window.location.reload();
        navigate('/user/signin');

        try {
            const id = localStorage.getItem('id');
            const response = await authService.userInfo(id);
            setFullName(response.data.fullName);
            setEmail(response.data.email);
        } catch (error) {
            console.error('Failed to fetch user:', error);
        }
    };

    // Format currency for display
    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(amount || 0);
    };

    // Format percentage
    const formatPercentage = (percentage) => {
        return `${(percentage || 0).toFixed(2)}%`;
    };

    return (
        <HeaderWrapper>
            <div className="header">
                <nav className="navbar py-4">
                    <div className="container-xxl">
                        <div className="h-right d-flex align-items-center mr-5 mr-lg-0 order-1 ms-auto">
                            <div className="portfolio-summary me-3">
                                <div className="portfolio-item">
                                    <div className="portfolio-label">Total Invested</div>
                                    <div className="portfolio-value invested">
                                        {formatCurrency(portfolioData.totalInvestedAmount)}
                                    </div>
                                </div>
                                <div className="portfolio-item">
                                    <div className="portfolio-label">Wallet Balance</div>
                                    <div className="portfolio-value balance">
                                        {formatCurrency(portfolioData.totalWalletBalance)}
                                    </div>
                                </div>
                                <div className="portfolio-item">
                                    <div className="portfolio-label">Current Profit</div>
                                    <div className="portfolio-value profit">
                                        {formatCurrency(portfolioData.totalCurrentProfit)}
                                        <span className="profit-percentage">
                                            ({formatPercentage(portfolioData.totalCurrentProfitPercentage)})
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="d-flex header-wallet-icon">
                                <Link className='btn btn-primary btn-modern lift' to="/user/wallet/topup">
                                    Topup Wallet
                                </Link>
                                <Link className="nav-link wallet-link" to="/user/wallet" title="Wallet">
                                    <div className="icon-wrapper">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 64 64">
                                            <path className="wallet-icon" d="M15,24c-3.86,0-7,2.691-7,6v20c0,3.309,3.14,6,7,6h41V32H15c-1.598,0-3-0.935-3-2s1.402-2,3-2h5.25 c0,0,1-5,5.75-5s6,5,6,5h22v-4H15z"/>
                                            <path className="wallet-icon" d="M42,4c-4.418,0-8,3.582-8,8s3.582,8,8,8c4.417,0,8-3.582,8-8S46.417,4,42,4z M42,16c-2.208,0-4-1.792-4-4 s1.792-4,4-4s4,1.792,4,4S44.208,16,42,16z"/>
                                            <path className="wallet-icon" d="M26,20c-4.418,0-8,3.582-8,8h4c0-2.208,1.792-4,4-4s4,1.792,4,4h4C34,23.582,30.418,20,26,20z"/>
                                        </svg>
                                    </div>
                                </Link>
                            </div>

                            {/* Enhanced Notifications Dropdown */}
                            <Dropdown className="notifications-dropdown">
                                <Dropdown.Toggle as="div" className="notification-trigger">
                                    <div className="notification-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                                            <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                                        </svg>
                                        {notificationCount > 0 && (
                                            <span className="notification-badge">{notificationCount}</span>
                                        )}
                                    </div>
                                </Dropdown.Toggle>

                                <Dropdown.Menu className="notification-dropdown-menu">
                                    <div className="dropdown-header">
                                        <h6 className="mb-0">Notifications</h6>
                                        <span className="badge bg-primary">{notificationCount}</span>
                                    </div>
                                    
                                    <div className="notification-list" style={{ maxHeight: '350px', overflowY: 'auto' }}>
                                        {notifications.length === 0 ? (
                                            <div className="text-center p-3 text-muted">No notifications</div>
                                        ) : (
                                            notifications.map((notification) => (
                                            <Dropdown.Item
                                                key={notification._id}
                                                className="notification-item"
                                            >
                                                <div className="notification-content d-flex">
                                                    <div className="notification-avatar">
                                                        <div className="avatar-initials">
                                                            {notification.title?.charAt(0).toUpperCase()}
                                                        </div>
                                                    </div>
                                                    <div className="notification-body ms-2">
                                                        <div className="notification-header d-flex justify-content-between">
                                                            <span className="notification-name">{notification.title}</span>
                                                            <span className="notification-time text-muted" style={{ fontSize: '12px' }}>
                                                                {new Date(notification.createdAt).toLocaleDateString()}
                                                            </span>
                                                        </div>
                                                        <p className="notification-message text-muted small mb-0">
                                                            {notification.message}
                                                        </p>
                                                    </div>
                                                </div>
                                            </Dropdown.Item>
                                            ))
                                        )}
                                    </div>
                                </Dropdown.Menu>
                            </Dropdown>

                            {/* Enhanced User Profile Dropdown */}
                            <Dropdown className="user-profile-dropdown">
                                <Dropdown.Toggle as="div" className="profile-trigger">
                                    <div className="profile-avatar">
                                        <img src="../assets/images/profile_av.svg" alt="profile" />
                                        <div className="online-indicator"></div>
                                    </div>
                                </Dropdown.Toggle>

                                <Dropdown.Menu className="profile-dropdown-menu">
                                    <div className="profile-header">
                                        <div className="profile-info">
                                            <img src="../assets/images/profile_av.svg" alt="profile" />
                                            <div className="profile-details">
                                                <h6 className="profile-name">{fullName}</h6>
                                                <p className="profile-email">{email}</p>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <hr className="dropdown-divider" />
                                    
                                    <div className="profile-menu">
                                        <Dropdown.Item as={Link} to="/user/profile" className="profile-menu-item">
                                            <span>My Profile</span>
                                        </Dropdown.Item>
                                        <Dropdown.Item as={Link} to="/user/wallet" className="profile-menu-item">
                                            <span>Wallet</span>
                                        </Dropdown.Item>
                                        
                                        <hr className="dropdown-divider" />
                                        
                                        <Dropdown.Item as="button" onClick={handleLogout} className="profile-menu-item logout-btn">
                                            <i className="fas fa-sign-out-alt me-3"></i>
                                            <span>Sign Out</span>
                                        </Dropdown.Item>
                                    </div>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>

                        <button className="navbar-toggler p-0 border-0 menu-toggle order-3" type="button" data-bs-toggle="collapse" data-bs-target="#mainHeader">
                            <span className="fa fa-bars"></span>
                        </button>
                        
                        <div className="order-0 col-lg-4 col-md-4 col-sm-12 col-12 mb-3 mb-md-0 d-flex align-items-center">
                            <div className="main-search border-start px-3 flex-fill"></div>
                        </div>
                    </div>
                </nav>
            </div>
        </HeaderWrapper>
    );
};

export default Header;

const HeaderWrapper = styled.div`
    /* Portfolio Summary Styles */
    .portfolio-summary {
        display: flex;
        align-items: center;
        gap: 20px;
        margin-right: 25px;
        padding: 12px 20px;
        background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
        border-radius: 12px;
        border: 1px solid #e9ecef;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }

    .portfolio-item {
        text-align: center;
        min-width: 100px;
    }

    .portfolio-label {
        font-size: 11px;
        font-weight: 500;
        color: #6c757d;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        margin-bottom: 4px;
    }

    .portfolio-value {
        font-size: 14px;
        font-weight: 700;
        line-height: 1.2;
        
        &.invested {
            color: #007bff;
        }
        
        &.balance {
            color: #28a745;
        }
        
        &.profit {
            color: #17a2b8;
            display: flex;
            flex-direction: column;
            align-items: center;
        }
    }

    .profit-percentage {
        font-size: 10px;
        font-weight: 500;
        color: #6c757d;
        margin-top: 2px;
    }

    .header-wallet-icon {
        margin-right: 20px;
        display: flex;
        align-items: center;
        gap: 15px;
    }

    .btn-modern {
        border-radius: 12px;
        padding: 10px 20px;
        font-weight: 500;
        border: none;
        box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
        transition: all 0.3s ease;
        
        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(0, 123, 255, 0.4);
        }
    }

    .wallet-link {
        .icon-wrapper {
            padding: 10px;
            border-radius: 12px;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            transition: all 0.3s ease;
            
            &:hover {
                transform: scale(1.1);
                box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
            }
        }
        
        .wallet-icon {
            fill: white;
        }
    }

    /* Notifications Dropdown Styles */
    .notifications-dropdown {
        margin-right: 20px;
        
        .notification-trigger {
            cursor: pointer;
            padding: 8px;
        }
        
        .notification-icon {
            position: relative;
            padding: 10px;
            border-radius: 12px;
            background: #f8f9fa;
            color: #6c757d;
            transition: all 0.3s ease;
            
            &:hover {
                background: #e9ecef;
                color: #495057;
                transform: scale(1.05);
            }
            
            svg {
                display: block;
            }
        }
        
        .notification-badge {
            position: absolute;
            top: 2px;
            right: 2px;
            background: #dc3545;
            color: white;
            border-radius: 50%;
            font-size: 10px;
            font-weight: bold;
            min-width: 18px;
            height: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 2px solid white;
        }
    }

    .notification-dropdown-menu {
        width: 360px;
        border: none;
        border-radius: 16px;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
        padding: 0;
        margin-top: 8px;
        
        .dropdown-header {
            padding: 20px 24px 16px;
            border-bottom: 1px solid #e9ecef;
            display: flex;
            justify-content: space-between;
            align-items: center;
            
            h6 {
                margin: 0;
                font-weight: 600;
                color: #2c3e50;
            }
            
            .badge {
                font-size: 11px;
                padding: 4px 8px;
            }
        }
        
        .notification-list {
            max-height: 400px;
            overflow-y: auto;
        }
        
        .notification-item {
            padding: 16px 24px;
            border: none;
            border-bottom: 1px solid #f8f9fa;
            background: transparent;
            transition: background-color 0.2s ease;
            
            &:hover {
                background-color: #f8f9fa;
            }
            
            &:last-child {
                border-bottom: none;
            }
        }
        
        .notification-content {
            display: flex;
            align-items: flex-start;
            gap: 12px;
        }
        
        .notification-avatar {
            flex-shrink: 0;
            
            img {
                width: 40px;
                height: 40px;
                border-radius: 50%;
                object-fit: cover;
            }
            
            .avatar-initials {
                width: 40px;
                height: 40px;
                border-radius: 50%;
                background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                color: white;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 600;
                font-size: 14px;
            }
        }
        
        .notification-body {
            flex: 1;
            min-width: 0;
        }
        
        .notification-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 4px;
        }
        
        .notification-name {
            font-weight: 600;
            color: #2c3e50;
            font-size: 14px;
        }
        
        .notification-time {
            font-size: 12px;
            color: #6c757d;
        }
        
        .notification-message {
            margin: 0;
            font-size: 13px;
            color: #6c757d;
            line-height: 1.4;
        }
        
        .notification-type-badge {
            display: inline-block;
            padding: 2px 8px;
            border-radius: 12px;
            font-size: 10px;
            font-weight: 500;
            margin-top: 6px;
            
            &.badge-success {
                background-color: #d4edda;
                color: #155724;
            }
            
            &.badge-info {
                background-color: #d1ecf1;
                color: #0c5460;
            }
            
            &.badge-warning {
                background-color: #fff3cd;
                color: #856404;
            }
        }
        
        .dropdown-footer {
            padding: 16px 24px;
            border-top: 1px solid #e9ecef;
            text-align: center;
            
            .view-all-link {
                color: #007bff;
                text-decoration: none;
                font-weight: 500;
                font-size: 14px;
                
                &:hover {
                    color: #0056b3;
                    text-decoration: underline;
                }
            }
        }
    }

    /* User Profile Dropdown Styles */
    .user-profile-dropdown {
        .profile-trigger {
            cursor: pointer;
            padding: 4px;
        }
        
        .profile-avatar {
            position: relative;
            
            img {
                width: 40px;
                height: 40px;
                border-radius: 50%;
                border: 2px solid #e9ecef;
                transition: all 0.3s ease;
                
                &:hover {
                    border-color: #007bff;
                    transform: scale(1.05);
                }
            }
            
            .online-indicator {
                position: absolute;
                bottom: 2px;
                right: 2px;
                width: 12px;
                height: 12px;
                background: #28a745;
                border: 2px solid white;
                border-radius: 50%;
            }
        }
    }

    .profile-dropdown-menu {
        width: 280px;
        border: none;
        border-radius: 16px;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
        padding: 0;
        margin-top: 8px;
        
        .profile-header {
            padding: 20px;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            border-radius: 16px 16px 0 0;
            
            .profile-info {
                display: flex;
                align-items: center;
                gap: 12px;
                
                img {
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                    border: 3px solid rgba(255, 255, 255, 0.3);
                }
                
                .profile-details {
                    flex: 1;
                    
                    .profile-name {
                        margin: 0;
                        color: white;
                        font-weight: 600;
                        font-size: 16px;
                    }
                    
                    .profile-email {
                        margin: 2px 0 0;
                        color: rgba(255, 255, 255, 0.8);
                        font-size: 13px;
                    }
                }
            }
        }
        
        .dropdown-divider {
            margin: 0;
            border-color: #e9ecef;
        }
        
        .profile-menu {
            padding: 8px 0;
        }
        
        .profile-menu-item {
            padding: 12px 20px;
            border: none;
            background: transparent;
            color: #495057;
            font-size: 14px;
            display: flex;
            align-items: center;
            text-decoration: none;
            transition: all 0.2s ease;
            
            &:hover {
                background-color: #f8f9fa;
                color: #007bff;
            }
            
            i {
                width: 20px;
                color: #6c757d;
            }
            
            &.logout-btn {
                color: #dc3545;
                
                &:hover {
                    background-color: #f8f9fa;
                    color: #dc3545;
                }
                
                i {
                    color: #dc3545;
                }
            }
        }
    }

    /* General Dropdown Styles */
    .dropdown-toggle::after {
        display: none;
    }
    
    .dropdown-menu {
        z-index: 1050;
    }
    
    /* Responsive Design */
    @media (max-width: 1200px) {
        .portfolio-summary {
            gap: 15px;
            padding: 10px 15px;
        }
        
        .portfolio-item {
            min-width: 85px;
        }
    }
    
    @media (max-width: 992px) {
        .portfolio-summary {
            gap: 12px;
            padding: 8px 12px;
            margin-right: 15px;
        }
        
        .portfolio-item {
            min-width: 75px;
        }
        
        .portfolio-label {
            font-size: 10px;
        }
        
        .portfolio-value {
            font-size: 13px;
        }
    }
    
    @media (max-width: 768px) {
        .portfolio-summary {
            display: none; /* Hide on mobile to save space */
        }
        
        .header-wallet-icon {
            gap: 10px;
            margin-right: 15px;
        }
        
        .btn-modern {
            padding: 8px 16px;
            font-size: 14px;
        }
        
        .notification-dropdown-menu,
        .profile-dropdown-menu {
            width: 300px;
        }
        
        .notifications-dropdown,
        .user-profile-dropdown {
            margin-right: 10px;
        }
    }
    
    @media (max-width: 576px) {
        .portfolio-summary {
            flex-direction: column;
            gap: 8px;
            padding: 8px;
            margin-right: 10px;
        }
        
        .portfolio-item {
            min-width: auto;
        }
    }
`;